module.exports = __webpack_public_path__ + "static/media/icon_notifications.d66931f2.svg";